module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Space Grey Aluminum + Black Open.5afd15f2.png";